import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://f4cf116b35595acd7e8e96379530b464@o4511090359205888.ingest.de.sentry.io/4511090370609232',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.2,
  sendDefaultPii: false,
})
